import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight, FaHeart } from "react-icons/fa";
import projectImg1 from "../../../assets-user/projectImg1.png";
import projectImg2 from "../../../assets-user/projectImg2.png";
import projectImg3 from "../../../assets-user/projectImg3.png";

const PropertiesForSale = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      id: 1,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image: projectImg1,
      badge: "RERA",
    },
    {
      id: 2,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image: projectImg2,
      badge: "RERA",
    },
    {
      id: 3,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image: projectImg3,
      badge: "RERA",
    },
    {
      id: 4,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image:
        "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop",
      badge: "RERA",
    },
    {
      id: 5,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop",
      badge: "RERA",
    },
    {
      id: 6,
      title: "MI CASA",
      description: "1, 2, 3 BHK Apartment in Kalinga Nagar, Bhubaneswar",
      price: "₹19 Cr - 2.8 Cr",
      image:
        "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=800&h=600&fit=crop",
      badge: "RERA",
    },
  ];

  // Calculate how many items to show per slide based on screen size
  const getItemsPerSlide = () => {
    if (typeof window !== "undefined") {
      if (window.innerWidth >= 1024) return 3; // lg breakpoint
      if (window.innerWidth >= 640) return 2; // sm breakpoint
      return 1; // mobile
    }
    return 3; // default
  };

  const itemsPerSlide = getItemsPerSlide();
  const maxSlide = Math.max(0, projects.length - itemsPerSlide);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= maxSlide ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? maxSlide : prev - 1));
  };

  // Get the projects to display based on current slide
  const displayedProjects = projects.slice(
    currentSlide,
    currentSlide + itemsPerSlide
  );

  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init({
        duration: 800, // Animation duration in milliseconds
        once: true, // Animation happens only once on scroll
      });
    }
  }, []);

  return (
    <div className="w-full">
      <div className="mx-auto">
        {/* Title */}
        <h2
          className="font-poppins font-medium text-[22.09px] leading-[150%] tracking-[0.01em] text-[#031722] mb-1 sm:mb-2 md:mb-3 lg:mb-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          20+ Properties for sell
        </h2>

        {/* Carousel Container */}
        <div className="relative overflow-hidden">
          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 sm:p-3 shadow-lg"
            aria-label="Previous slide"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <FaChevronLeft className="text-gray-700 text-base sm:text-lg lg:text-xl" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-2 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-2 sm:p-3 shadow-lg"
            aria-label="Next slide"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <FaChevronRight className="text-gray-700 text-base sm:text-lg lg:text-xl" />
          </button>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
            {displayedProjects.map((project, index) => (
              <div
                key={project.id}
                className="bg-white rounded-lg overflow-hidden shadow-md"
                data-aos="fade-up"
                data-aos-delay={300 + index * 100}
              >
                {/* Image Container */}
                <div className="relative w-full h-[200px] sm:h-[220px] lg:h-[240px] xl:h-[260px] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />

                  {/* RERA Badge */}
                  <div className="absolute top-3 left-3 sm:top-4 sm:left-4">
                    <div className="bg-white bg-opacity-90 rounded-full px-2.5 py-1 sm:px-3 sm:py-1.5 flex items-center gap-1.5">
                      <div className="w-3 h-3 sm:w-3.5 sm:h-3.5 bg-gray-300 rounded-full"></div>
                      <span className="text-[10px] sm:text-[11px] lg:text-[12px] font-medium text-gray-700">
                        {project.badge}
                      </span>
                    </div>
                  </div>

                  {/* Heart Icon */}
                  <button className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-white bg-opacity-90 rounded-full p-2 sm:p-2.5">
                    <FaHeart className="text-gray-400 text-sm sm:text-base" />
                  </button>
                </div>

                {/* Content */}
                <div className="p-4">
                  <h3 className="font-poppins font-medium text-[15.82px] leading-[150%] tracking-[0.01em]  mb-2 text-[#031722]">
                    {project.title}
                  </h3>

                  <p className="font-poppins font-normal text-[12.31px] leading-[100%] tracking-[0.01em] text-[#6A6A6A] mb-3">
                    {project.description}
                  </p>

                  <p className="font-poppins font-medium text-[10.55px] leading-[100%] tracking-[0.01em] text-[#202020] mb-4">
                    {project.price}
                  </p>

                  {/* View Details Button */}
                  <button className="w-full border-2 border-red-600 text-red-600 font-medium py-2 sm:py-2.5 lg:py-3 rounded-3xl text-[13px] sm:text-[14px] lg:text-[15px] xl:text-[16px]">
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertiesForSale;
